import { installBuildApk } from '@/api/builds';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import type { IBuild } from '@/entities/build.entity';
import { SendIcon } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

interface BuildInstallButtonProps {
	build: IBuild;
	className?: string;
}

export default function BuildInstallButton({ build, className }: BuildInstallButtonProps) {
	const [loading, setLoading] = useState(false);
	const canInstall = Boolean(build.successBuilded && build.hasApk);
	const isUnavailable = Boolean(build.successBuilded && !build.hasApk);

	async function handleInstall() {
		if (!canInstall) return;

		setLoading(true);
		try {
			await installBuildApk(build.id);
			toast.success('APK отправлен в Telegram', { position: 'top-center', duration: 2500 });
		} catch {
			// error toast handled by api interceptor
		} finally {
			setLoading(false);
		}
	}

	if (!canInstall && !isUnavailable) return null;

	return (
		<Button
			variant='outline'
			size='sm'
			className={className}
			disabled={loading || isUnavailable}
			onClick={handleInstall}
			title={isUnavailable ? 'Файл отсутствует, пересоберите билд' : undefined}
		>
			{loading ? <Spinner className='size-4' /> : <SendIcon size={16} />}
			{isUnavailable ? 'APK недоступен' : 'Установить'}
		</Button>
	);
}
